// TRU Energy Live Orders Popup JavaScript
(function() {
  // Array of sample orders
  const orders = [
    { name: "Sharod", location: "FL", product: "TRU Energy 2 Bottles", time: "13 minutes ago" },
    { name: "Frank", location: "CA", product: "TRU Energy 1 Bottle", time: "28 minutes ago" },
    { name: "Tilo", location: "CA", product: "TRU Energy 5 Bottles", time: "44 minutes ago" },
    { name: "Mike", location: "GA", product: "TRU Energy 4 Bottles", time: "59 minutes ago" },
    { name: "Jonathan", location: "CA", product: "TRU Energy 6 Bottles", time: "1 hour 16 minutes ago" },
    { name: "Jesús", location: "CO", product: "TRU Energy 4 Bottles", time: "1 hour 34 minutes ago" },
    { name: "Frank", location: "CA", product: "TRU Energy 1 Bottle", time: "1 hour 53 minutes ago" },
    { name: "Rob", location: "MI", product: "TRU Energy 3 Bottles", time: "2 hours 13 minutes ago" },
    { name: "Dr. Tim", location: "CA", product: "TRU Energy 1 Bottle", time: "2 hours 34 minutes ago" },
    { name: "Thomas", location: "CA", product: "TRU Energy 5 Bottles", time: "2 hours 56 minutes ago" },
    { name: "Salumu", location: "FL", product: "TRU Energy 1 Bottle", time: "12 minutes ago" },
    { name: "Sharod", location: "FL", product: "TRU Energy 1 Bottle", time: "26 minutes ago" },
    { name: "Jimmy", location: "OR", product: "TRU Energy 3 Bottles", time: "41 minutes ago" },
    { name: "Ruth", location: "CA", product: "TRU Energy 1 Bottle", time: "57 minutes ago" },
    { name: "Brandon", location: "OH", product: "TRU Energy 1 Bottle", time: "1 hour 14 minutes ago" },
    { name: "Dylan", location: "MN", product: "TRU Energy 1 Bottle", time: "1 hour 32 minutes ago" },
    { name: "Thomas", location: "CA", product: "TRU Energy 2 Bottles", time: "1 hour 51 minutes ago" },
    { name: "Nicholas", location: "PA", product: "TRU Energy 1 Bottle", time: "2 hours 11 minutes ago" },
    { name: "DeAuszlo", location: "CA", product: "TRU Energy 1 Bottle", time: "2 hours 32 minutes ago" },
    { name: "AC Maritimo", location: "FL", product: "TRU Energy 4 Bottles", time: "2 hours 54 minutes ago" },
    { name: "Eric", location: "CA", product: "TRU Energy 1 Bottle", time: "13 minutes ago" },
    { name: "Ashley", location: "PA", product: "TRU Energy 1 Bottle", time: "28 minutes ago" },
    { name: "Christina", location: "NH", product: "TRU Energy 1 Bottle", time: "43 minutes ago" },
    { name: "Andrew", location: "CA", product: "TRU Energy 1 Bottle", time: "59 minutes ago" },
    { name: "Sidney", location: "OR", product: "TRU Energy 1 Bottle", time: "1 hour 16 minutes ago" },
    { name: "Lacy", location: "APO", product: "TRU Energy 2 Bottles", time: "1 hour 34 minutes ago" },
    { name: "Demaray", location: "TX", product: "TRU Energy 1 Bottle", time: "1 hour 53 minutes ago" },
    { name: "Haley", location: "FL", product: "TRU Energy 1 Bottle", time: "2 hours 13 minutes ago" },
    { name: "Michael", location: "CA", product: "TRU Energy 1 Bottle", time: "2 hours 34 minutes ago" }
  ];

  // Display popup function
  function showLiveOrder() {
    const randomOrder = orders[Math.floor(Math.random() * orders.length)];
    const popup = document.getElementById('live-orders-popup');
    popup.innerHTML = `
      <div class="popup-content">
        <div class="popup-image">
          <img style="border-radius: 5px;" src="https://cdn.shopify.com/s/files/1/2443/2395/files/Tru-Energy-IcedTeaLemonade_4000x4000_Zoom.png?v=1733773320" alt="Product Image">
          <span class="glow-dot"></span>
        </div>
        <div class="popup-text">
          <div class="popup-line">
            <div class="name-location"><strong>${randomOrder.name} from ${randomOrder.location}</strong></div>
          </div>
          <div class="popup-line product-name"><span class="ordered-text">ordered</span> <strong><span class="product-text">${randomOrder.product}</span></strong></div>
          <div class="popup-line order-time">${randomOrder.time}</div>
          <div class="verified-buyer-badge">Verified Buyer</div>
        </div>
      </div>
    `;
    popup.style.display = 'block';

    setTimeout(() => {
      popup.classList.add('popup-hide');
    }, 6000); // Show for 5 seconds

    setTimeout(() => {
      popup.style.display = 'none';
      popup.classList.remove('popup-hide');
      setTimeout(showLiveOrder, getRandomTimeInterval());
    }, 6500);
  }

  // Random time intervals between popups
  function getRandomTimeInterval() {
    const intervals = [20000, 20000, 20000]; // 20s, 20s, 20s
    return intervals[Math.floor(Math.random() * intervals.length)];
  }

  // Start the popup display
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(showLiveOrder, getRandomTimeInterval());
  });
})();
